<template>
  <div>
    <!-- <tui-image-editor ref="image_editor" :options="options" @objectActivated="object_added" /> -->

    <!-- <Fabric ref="canvas" :width="'100%'" :height="500"></Fabric> -->

    <div v-if="!background_image">
      <b-input-group>
        <b-form-file v-model="file" placeholder="Choose an Image" drop-placeholder="Drop image file here..." accept="image/*"></b-form-file>
        <b-input-group-append>
          <LoadingButton :loading="is_uploading" @click="upload_image">Upload</LoadingButton>
        </b-input-group-append>
      </b-input-group>
    </div>

    <div :hidden="!background_image">
      <canvas id="canvas" width="900" height="500"></canvas>

      <b-button @click="add_variable('{{first_name}}')">Add first name</b-button>
      <b-button @click="add_text">Add text</b-button>
      <b-button @click="add_image_variable('website')">Add website</b-button>
      <b-button @click="add_image_variable('logo')">Add logo</b-button>
      <b-button @click="export_image">Save</b-button>
      <b-button @click="clear">Clear</b-button>

      <div style="visibility: hidden">
        <span style="font-family: 'Handwriting1'">a</span>
        <span style="font-family: 'Handwriting2'">a</span>
        <span style="font-family: 'Handwriting3'">a</span>
        <span style="font-family: 'Handwriting4'">a</span>
        <span style="font-family: 'allura'">a</span>
        <span style="font-family: 'bilbo'">a</span>
        <span style="font-family: 'caveat'">a</span>
      </div>

      <div v-if="selected">
        <div v-if="selected_object.type === 'i-text' || selected_object.type === 'text'">
          <b-form-group label="Font">
            <b-select :options="['Handwriting1', 'Handwriting2', 'Handwriting3', 'Handwriting4', 'allura', 'bilbo', 'caveat', 'Montserrat', 'Impact', 'Arial', 'Comic Sans MS', 'Andale Mono', 'Courier New', 'Georgia', 'Times New Roman', 'Trebuchet MS', 'Verdana']" :value="selected_object.fontFamily" @input="selected_update_font"></b-select>
          </b-form-group>

          <b-form-group label="Colour">
            <b-form-input type="color" :value="selected_object.fill" @input="selected_update_colour" />
          </b-form-group>

          <b-button @click="selected_delete">Delete</b-button>
        </div>
        <div v-if="selected_object.type === 'image'">
          <b-button @click="selected_delete">Delete</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fabric } from "fabric"
import { db, storage, _firebase, config } from '@/main.js'

function create_image(url) {
  return new Promise((resolve, reject) => {
    fabric.Image.fromURL(url, resolve, {crossOrigin: 'anonymous'})
  })
}

export default {
  props: ['image_template_id'],
  data() {
    return {
      image_editor: null,
      canvas: null,
      selected: null,
      background_image: null,
      file: null,
      is_uploading: false,
    }
  },
  computed: {
    selected_object() {
      if (!this.canvas) {
        return null
      }

      return this.canvas.getActiveObject()
    }
  },
  methods: {
    async upload_image() {
      let src = window.URL.createObjectURL(this.file)

      if (!src) {
        this.$swal({title: 'No file', text: "Please upload a video file", icon: 'warning'})
        return false
      }

      this.is_uploading = true

      let location = `image_template/${this.image_template_id}/${db.collection('media').doc().id}.jpg`

      let snap = storage.ref().child(location).put(this.file)
      snap = await snap

      let url = await snap.ref.getDownloadURL()
      url = `https://${config.firebase_config.storageBucket}/${location}`

      this.is_uploading = false

      this.background_image = url
      this.file = null

      this.load()
    },
    async load(svg) {
      await this.add_image(this.background_image, {selectable: false}, true)

      // TODO load SVG
    },
    clear() {
      this.background_image = null
      this.canvas.clear()
    },
    async export_image() {
      if (!this.background_image) {
        return null
      }

      let svg = this.canvas.toSVG()
      let image = this.canvas.toDataURL()

      let style_text = `
        <style type="text/css">
          @font-face {font-family: allura; src: url('https://${config.firebase_config.storageBucket}/allura.ttf')}
          @font-face {font-family: bilbo; src: url('https://${config.firebase_config.storageBucket}/bilbo.ttf')}
          @font-face {font-family: caveat; src: url('https://${config.firebase_config.storageBucket}/caveat.ttf')}
          @font-face {font-family: Handwriting1; src: url('https://${config.firebase_config.storageBucket}/Handwriting1.ttf')}
          @font-face {font-family: Handwriting2; src: url('https://${config.firebase_config.storageBucket}/Handwriting2.ttf')}
          @font-face {font-family: Handwriting3; src: url('https://${config.firebase_config.storageBucket}/Handwriting3.ttf')}
          @font-face {font-family: Handwriting4; src: url('https://${config.firebase_config.storageBucket}/Handwriting4.ttf')}
        </style>
      `

      svg = svg.replace('<defs>', `<defs>${style_text}`)

      let location = `image_template/${this.image_template_id}/${db.collection('media').doc().id}.jpg`
      let snap = storage.ref().child(location).putString(image, 'data_url')
      snap = await snap

      let image_url = await snap.ref.getDownloadURL()
      image_url = `https://${config.firebase_config.storageBucket}/${location}`

      // console.log(svg)
      // console.log(image_url)

      return {svg: svg, image: image_url}
    },
    async add_text() {
      let text = new fabric.IText('Enter text', {fontFamily: 'Arial', fontSize: 30, angle: 0})

      text.setControlsVisibility({mt: false, tl: false, tr: false, bl: false, mb: false, ml: false, mr: false})

      let object = this.canvas.add(text)

      this.canvas.setActiveObject(this.canvas.item(this.canvas.getObjects().length-1))
      this.selected = object
      this.$forceUpdate()

      return object
    },
    async add_variable(variable) {
      let text = new fabric.Text(variable, {fontFamily: 'Handwriting3', fontSize: 30, angle: 0})

      text.setControlsVisibility({mt: false, tl: false, tr: false, bl: false, mb: false, ml: false, mr: false})

      let object = this.canvas.add(text)

      this.canvas.setActiveObject(this.canvas.item(this.canvas.getObjects().length-1))
      this.selected = object
      this.$forceUpdate()

      return object
    },
    async add_image_variable(image_variable) {
      let url = null
      if (image_variable === 'website') {
        url = 'https://via.placeholder.com/400x300'
      } else {
        url = 'https://via.placeholder.com/200x200'
      }

      let object = await this.add_image(url, {lockUniScaling: true, lockAspectRatio: true})

      this.canvas.setActiveObject(this.canvas.item(this.canvas.getObjects().length-1))
      this.selected = object
      this.$forceUpdate()

      return object
    },
    async add_image(url, options, background) {
      if (!options) options = {}
      let image = await create_image(url)
      for (let option of Object.keys(options)) {
        image[option] = options[option]
      }

      if (background) { // Resize to fit canvas
        if (image.width / this.canvas.width > image.height / this.canvas.height) {
          image.scaleToWidth(this.canvas.width)
        } else {
          image.scaleToHeight(this.canvas.height)
        }
      }

      image.setControlsVisibility({mt: false, tl: false, tr: false, bl: false, mb: false, ml: false, mr: false})

      let object = this.canvas.add(image)

      if (!background) {
        this.canvas.setActiveObject(this.canvas.item(this.canvas.getObjects().length-1))
        this.selected = object
        this.$forceUpdate()
      }

      return object
    },
    selected_delete() {
      this.canvas.remove(this.canvas.getActiveObject())
      this.selected = null
    },
    selected_update_font(val) {
      this.canvas.getActiveObject().set("fontFamily", val)
      this.canvas.renderAll()
    },
    selected_update_colour(val) {
      this.canvas.getActiveObject().set("fill", val)
      this.canvas.renderAll()
    },
    on_mousedown(evt) {
      this.selected = null

      if (!this.canvas.getActiveObject()) {
        return
      }

      this.selected = this.canvas.getActiveObject()
    },
  },
  mounted() {
    this.canvas = new fabric.Canvas('canvas')
    this.canvas.on('mouse:down', this.on_mousedown)
  }
}
</script>


<style>

.tie-text-effect-button {
  display: none !important;
}

.tui-image-editor-header-logo {
  display: none !important;
}

.tui-image-editor-download-btn {
  display: none !important;
}

.tui-image-editor-help-menu {
  display: none !important;
}

.tui-image-editor-partition {
  display: none !important;
}

li.tie-text-align-button {
  display: none !important;
}

</style>
